import React from "react";

export default function iconBack() {
    return (
        <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path opacity="0.54" fillRule="evenodd" clipRule="evenodd" d="M15.6299 7.40894L10.9612 12.0143L15.6299 16.6197L14.209 18.0214L8.11943 12.0143L14.209 6.00729L15.6299 7.40894Z" fill="#FFFEFE"/>
        </svg>
    )
}